/* Original Hearfox UI; native Shopify product forms handle purchasing. */
(() => {
  if (window.hearfoxUIInitialized) return;
  window.hearfoxUIInitialized = true;
  function initialize(root = document) {
    root.querySelectorAll('[data-hf-home]').forEach(home => {
      if (home.dataset.initialized) return;
      home.dataset.initialized = 'true';
      const track = home.querySelector('.hf-hero__slides');
      const controls = [...home.querySelectorAll('[data-hf-slide]')];
      controls.forEach(control => control.addEventListener('click', event => {
        event.preventDefault();
        track.scrollTo({left: track.clientWidth * Number(control.dataset.hfSlide), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      }));
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const active = Math.round(track.scrollLeft / track.clientWidth);
          controls.forEach((control, i) => control.setAttribute('aria-current', String(i === active)));
        });
      }, {passive: true});
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.hf-mobile-menu[open]').forEach(menu => {menu.open = false; menu.querySelector('summary').focus();});
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.hf-mobile-menu[open]').forEach(menu => {if (!menu.contains(event.target)) menu.open = false;});
  });
})();
